import style from './appItemsView.scss';

import linkEntriesCtrl from '../app.modal/appLinkEntriesModalCtrl';
import linkEntriesView from  '../app.modal/linkExistingEntriesModal.html';
import linkAssetsView from '../app.modal/linkExistingAssetsModal.html';
import appFileCtrl from '../app.sidenav/addNewFilesCtrl';
import appFileView from '../app.sidenav/addNewFilesModal.html';
import manageImageCtrl from '../app.modal/manageImageModalCtrl';
import manageImageView from '../app.modal/manageImageModal.html';

export default function ($rootScope, $scope, $http, $stateParams, $state, $cookies, $document, $uibModal, $q, $timeout, ngToast, UtilitiesFactory, CONFIG, Upload, ContentFulFactory) {
    'ngInject';
    $scope.style = style;

    let utilities = UtilitiesFactory.getUtilities();
    let contentType = $stateParams.contentType;

    let returnState = $stateParams.returnState;
    $scope.returnState = returnState;

    let endpoint = 'entries';

    let T = $scope.$root.T;
    let labelSingle = $scope.$root.TC(contentType.name);
    $scope.labelSingle = labelSingle;

    let formControls = contentType.fields;
    console.log(formControls);

    $scope.articlesList = [];
    $scope.images = [];

    let mode = $stateParams.mode;
    $scope.mode = mode;

    let preventDoubleRequest = false;

    console.log($stateParams);

    $scope.idParent = $stateParams.id;
    $scope.contentTypes = $stateParams.contentTypes;
    $scope.contentType = contentType.name.toLowerCase();
    $scope.contentTypeChild =  $stateParams.contentTypes;
    $scope.idChild = $stateParams.idChild;
    $scope.requestInProgress = false;

    $scope.setControlsToDirty = utilities.forms.setControlsToDirty;

    $scope.item = {};
    $scope.keywords = [];
    $scope.orientation = null;

    $scope.formControls = formControls;
    $scope.isPdf = utilities.strings.isPdf;

    $scope.fileUpload = false;

    $scope.types = ['text', 'table'];
    $scope.type = 'text';
    $scope.descriptionObj = {};


    $rootScope.$broadcast('selectionMenu', {context: 'article'});

    console.log('appItemsAddEditCtr()', mode, $scope.contentTypes, $scope.contentTypeChild, $scope.contentType, $scope.idParent, $scope.idChild);

    $scope.$watch('dirtyElems', function (dirty) {
        console.log('dirtyElems', dirty);
        if (dirty) {
            $rootScope.preventNavigation();
        }
        else {
            $rootScope.allowNavigation();
        }
    });


    /***
     * get All keywords
     */
    let getAllKeywords = () => {
        //console.warn(contentType);
        let number_items = 1000;
        let index = 1;

        let addingKeywords = (items) => {
            _.forEach(items, (item) => {
                if (!!item.fields && item.fields.hasOwnProperty('keywords')) {
                    item.fields.keywords.map( (value) => {
                        if (!$scope.keywords.includes(value)) {
                            $scope.keywords.push(value);
                        }
                    });
                }
            });
        };

        let recursiveService = (items, total) => {
            if (total > number_items) {
                number_items = number_items * index;
                index ++ ;
                ContentFulFactory.getKeywordsService(contentType.sys.id, 1000, number_items).then((data) => {
                    let items = data.data.items;
                    let total = data.data.total;

                    addingKeywords(items);

                    return recursiveService(items, total);
                });
            } else {
                console.warn('completed', $scope.keywords);
            }
        };

        ContentFulFactory.getKeywordsService(contentType.sys.id, 1000, 0).then((data) => {
            let items = data.data.items;
            let total = data.data.total;

            addingKeywords(items);

            recursiveService(items, total);
        });
    };


    /***
     * Bootstrap (mode)
     */
    let init = () => {
        if (mode === 'add') {
            $scope.primaryButtonLabel = T.ADD;
        } else {
            let config = {
                errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
            };
            getContent(config, $scope.idParent);
            $scope.primaryButtonLabel = T.SAVE;
        }

        $scope.submit = () => {
            $rootScope.dirtyElems = false;
            $scope.images_orient = angular.copy($scope.item['images']);
            $scope.item['images'] = $scope.images;
            if (!preventDoubleRequest) {
                preventDoubleRequest = true;
                linkEntry();
            }
        };
    };


    /***
     * Changed Event
     * @param value
     * @param type
     */
    $scope.changed = (value, type) =>{
        $rootScope.dirtyElems = true;
        if (type === 'text') {
            //console.log('changed', value, type);
            if (value.length > 0) {
                let result = _.filter(value, (v) => { return v !==" "});
                console.log('changed', result, value);
                $rootScope.dirtyElems = result.length <= 1 ? false : true;
            } else {
                $rootScope.dirtyElems = false;
            }
        }
    };

    /***
     * Change type
     * @param type
     */
    $scope.changeType = (type) => {
        $scope.type = type;
    };


    /***
     * Create a data for POST call
     * @returns {{}}
     */
    let dataToPost = () => {
        let result = {};

        formControls.forEach(control => {
            let id = control.id;

            result[id] = $scope.item[id];
            result['authorId'] = $rootScope.firebaseUser.uid;
            result['authorName'] = $rootScope.firebaseUser.name;
            if (result.hasOwnProperty('layout')) result['layout'] = $scope.type;


            //Images
            if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Asset' && result[id]) {
                if (id === 'images') {
                    let images = {};
                    let descr = {};

                    _.forEach($scope.images_orient, (image) => {
                        let id = !!image.id ? image.id : image.sys.id;
                        images[id] = image.orientation;
                        descr[id] = image.description;
                    });

                    result['imagesOrientation'] = images;
                    result['imagesText'] = descr;

                    console.warn(descr, result['imagesText']);
                }

                result[id] = _.map(result[id], value => ({
                    sys: {
                        type: 'Link',
                        linkType: 'Asset',
                        id: (value.hasOwnProperty('sys') ? value.sys.id : value.id)
                    }
                }));
            }

            // NavigationItem
            if (control.type === 'Link' && control.linkType === 'Entry' && result[id]) {
                result[id] = {
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: result[id]
                    }
                };
            }

            // Articles and Specials
            if (control.type === 'Array' && control.items.type === 'Link' && control.items.linkType === 'Entry' && result[id]) {
                result[id] = _.map(result[id], value => ({
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: value
                    }
                }));
            }

            if (id === 'keywords') {
                let array = [];
                _.map(result[id], (value) => {
                    array.push(value.text);
                });
                result[id] = array;
            }

            // Regions
            if (id === 'region') {
                let _region = JSON.parse($cookies.get('region'));
                result[id] = {
                    sys: {
                        'id': _region.sys.id,
                        'type': 'Link',
                        'linkType': 'Entry'
                    }
                };
            }
        });

        console.warn('result', result);
        return result;
    };

    /***
     *
     * @param config
     * @param id
     */
    let getContent = (config, id) => {
        $scope.isProgress = true;
        $http.get(`${CONFIG.customUploadUrl}contentful/entries?content_type=page&include=2&fields.articles.sys.id=${id}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {
            $scope.articlesUsed = data.data.items;
        });

        $http.get(`${CONFIG.customUploadUrl}contentful/entries?sys.id=${id}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {
            if (data.data.items.length > 0) {
                console.log('data.data', data.data.items);
                let orderImages = data.data.items[0].fields.images;
                let itemEndpoint = `${CONFIG.customUploadUrl}contentful/entries?include=5&sys.id=${id}&sys.type[ne]=${(new Date()).valueOf()}`;
                $http.get(itemEndpoint, config).then(data => {
                    //console.log('getContent()', data.data.items);

                    let itemFields = data.data.items[0].fields;
                    let assets = !!data.data.includes ? data.data.includes.Asset : [];
                    let imagesOrientation = !!data.data.items[0].fields.imagesOrientation ? data.data.items[0].fields.imagesOrientation : {};
                    let imagesText = !!data.data.items[0].fields.imagesText ? data.data.items[0].fields.imagesText : {};

                    itemFields.id = data.data.items[0].sys.id;
                    itemFields.updated = data.data.items[0].sys.updatedAt;
                    itemFields.created = data.data.items[0].sys.createdAt;

                    // add author to the json
                    itemFields.authorCreated = data.data.items[0].fields.hasOwnProperty('authorName') ? data.data.items[0].fields.authorName : '';

                    // get author "updated" name

                    // add author to the json
                    itemFields.authorModified = data.data.items[0].fields.hasOwnProperty('authorName') ? data.data.items[0].fields.authorName : '';


                    itemFields['images'] = [];

                    if (!!assets) {
                        assets.forEach( (asset) => {
                            let asst = {
                                __url: asset.fields.file.url,
                                __contentType: asset.fields.file.contentType,
                                id: asset.sys.id,
                                orientation: !!imagesOrientation[asset.sys.id] ? imagesOrientation[asset.sys.id] : 'top',
                                description: !!imagesText[asset.sys.id] ? imagesText[asset.sys.id] : ''
                            };
                            itemFields['images'].push(asst);
                        });
                    }

                    $scope.isProgress = false;
                    $scope.item = itemFields;
                    $scope.type = itemFields.layout || 'text';

                    /**
                     * Order the images list
                     */
                    let tempImages = [];
                    _.forEach(orderImages, (orderImg) => {
                        _.forEach($scope.item.images, (image) => {
                            if (orderImg.sys.id === image.id) {
                                tempImages.push(image);
                            }
                        });
                    });

                    $scope.item.images = tempImages;

                    let promises = [];
                    for (let item of $scope.item['images']) {
                        promises.push($http.get(`${CONFIG.customUploadUrl}contentful/assets/${item.id}`));
                    }


                    $q.all(promises).then( (data) => {
                        for (let itm of data) {
                            let dt = itm.data;
                            $scope.images.push({
                                sys: {
                                    type: 'Link',
                                    linkType: 'Asset',
                                    id: dt.sys.id
                                }
                            });
                        }
                    }, (e) => {
                        let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                        $rootScope.raven.captureException(errorMessage);
                        $rootScope.raven.showReportDialog();
                    });
                }, (e) => {
                    $scope.isProgress = false;
                    ngToast.create({
                        className: 'toast-danger',
                        content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                        timeout: 4000
                    });
                }, (e) => {
                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                    $rootScope.raven.captureException(errorMessage);
                    $rootScope.raven.showReportDialog();
                });
            } else {
                $state.go('^.list');
            }
        });

    };


    /***
     * Utility to linking or update the entry (articles)
     */
    let linkEntry = () => {
        $q.all(dataToPost()).then(data => {
            let _dataToPost = _.mapValues(data, value => ({
                en: value
            }));

            let config = {
                errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + labelSingle,
                headers: {
                    'X-Contentful-Content-Type': contentType.sys.id
                }
            };

            $scope.isProgress = true;
            if (mode === 'add') {
                return $http.post(`${CONFIG.cmApiUrl}entries`, {fields: _dataToPost}, config).then(data => {
                    let sys = data.data.sys;
                    let id = data.data.sys.id;
                    let config = {
                        successMessage: labelSingle + T.HTTP_POST_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + labelSingle,
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };

                    return $http.put(`${CONFIG.cmApiUrl}entries/${sys.id}/published`, null, config).then(() => {
                        $scope.isDone = false;
                        ngToast.create({
                            className: 'toast-success',
                            content: `${T.ARTICLE} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                            timeout: 5000
                        });

                        $rootScope.dirtyElems = false;
                        preventDoubleRequest = false;
                        $state.reload();
                        /*$state.go('^.edit', {
                            id: id,
                            page: 1
                        });*/

                    }, () => $http.delete(`${CONFIG.cmApiUrl}entries/${sys.id}`));
                }, (e) => {
                    preventDoubleRequest = false;
                    $scope.isDone = false;
                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                    $rootScope.raven.captureException(errorMessage);
                    $rootScope.raven.showReportDialog();
                });
            } else {
                return $http.get(`${CONFIG.cmApiUrl}entries/${$scope.idParent}?sys.type[ne]=${(new Date()).valueOf()}`, config).then(data => {
                    let sys = data.data.sys;

                    let config = {
                        successMessage: labelSingle + T.HTTP_POST_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_POST_ERROR_NOTIFICATION + labelSingle,
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };
                    return $http.put(`${CONFIG.cmApiUrl}entries/${$scope.idParent}` , {fields: _dataToPost}, config).then(data => {
                        sys = data.data.sys;

                        let config = {
                            successMessage: labelSingle + T.HTTP_PUT_SUCCESS_NOTIFICATION,
                            errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + labelSingle,
                            headers: {
                                'X-Contentful-Version': sys.version
                            }
                        };

                        return $http.put(`${CONFIG.cmApiUrl}entries/${$scope.idParent}/published`, null, config).then(() => {
                            ngToast.create({
                                className: 'toast-success',
                                content: `${T.ARTICLE} ${T.HTTP_PUT_SUCCESS_NOTIFICATION}`,
                                timeout: 5000
                            });
                            $rootScope.dirtyElems = false;
                            preventDoubleRequest = false;
                            $state.reload();
                        });
                    });
                }, (e) => {
                    preventDoubleRequest = false;
                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                    $rootScope.raven.captureException(errorMessage);
                    $rootScope.raven.showReportDialog();
                });
            }

        }).finally(() => {
            preventDoubleRequest = false;
            $scope.requestInProgress = false;
            $scope.isProgress = false;
        });
    };


    /***
     * Open modal for add/remove existing entries
     * @param entry
     */
    $scope.linkExistingEntries = (entry) => {
        let entry_rough = angular.copy(entry);
        entry = (entry.toLowerCase().charAt(entry.length - 1) == 's') ? entry.substring(0, entry.length - 1) : entry;
        let endpoint = `entries?content_type=${entry}&order=fields.title&order=-sys.createdAt&sys.type[ne]=${(new Date()).valueOf()}`;
        endpoint += `&skip=${CONFIG.paginationResultsPerPageModal}&limit=${CONFIG.paginationResultsPerPageModal}`;
        let config = {
            errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
        };

        let modalInstance = $uibModal.open({
            template: linkEntriesView,
            controller: linkEntriesCtrl,
            controllerAs: 'vm',
            resolve: {
                id() {
                  return $stateParams.id;
                },
                items($http) {
                    return $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`, config);
                },
                entry() {
                    return entry_rough;
                },
                selectedItems() {
                    return $scope.item;
                },
                formControls() {
                    return formControls;
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
            console.log('selectedItem', selectedItem);
            let config = {
                errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
            };
            getContent(config, selectedItem.id);
            $document.scrollTop(0, 1000);
        }, () => {
            console.log(`Modal dismissng ed at: ${new Date()}`);
            $document.scrollTop(0, 1000);
        });
    };


    /***
     * Delete Article
     * @param entry
     * @param item
     */
    $scope.deleteItem = (entry, item) => {
        let entry_rough = angular.copy(entry);

        for (let itm_id of $scope.item[entry_rough]) {
            if (itm_id === item.id) {
                let position = $scope.item[entry_rough].indexOf(itm_id);
                $scope.item[entry_rough].splice(position, 1);
            }
        }

        let config = {
            errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelSingle
        };

        $q.all(dataToPost()).then(data => {
            let dataToPost = _.mapValues(data, value => ({
                en: value
            }));

            $http.get(`${CONFIG.cmApiUrl + endpoint}/${$stateParams.id}?sys.type[ne]=${(new Date()).valueOf()}`, config).then(data => {
                let sys = data.data.sys;

                let config = {
                    errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + labelSingle,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                console.log(dataToPost);

                return $http.put(`${CONFIG.cmApiUrl + endpoint}/${$stateParams.id}`, {fields: dataToPost}, config).then(data => {
                    sys = data.data.sys;

                    let config = {
                        successMessage: labelSingle + T.HTTP_PUT_SUCCESS_NOTIFICATION,
                        errorMessage: T.HTTP_PUT_ERROR_NOTIFICATION + labelSingle,
                        headers: {
                            'X-Contentful-Version': sys.version
                        }
                    };

                    return $http.put(`${CONFIG.cmApiUrl}entries/${$stateParams.id}/published`, null, config).then(() => {
                        $state.go(returnState || '^.list');
                    }, (e) => {
                        let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                        $rootScope.raven.captureException(errorMessage);
                        $rootScope.raven.showReportDialog();
                    });
                });
            });
        });
    };


    /***
     * Remove specific element from Array
     * @param array
     * @param element
     */
    $scope.removeElemFromArray = (array, element) => {
        $scope.images = _.filter($scope.images, (img) => {
            let id = img.hasOwnProperty('sys') ? img.sys.id : img.id;
            return id !== element.id
        });

        const index = array.indexOf(element);

        ngToast.create({
            className: 'toast-warning',
            content: `${T.REMOVE_IMAGE}`,
            timeout: 4000
        });
        return array.splice(index, 1);
    };


    /***
     * Check if image has __url property (it means that image is already published)
     * @param img
     * @returns {*|boolean}
     */
    $scope.checkIfPublished = (img) => {
        return img.hasOwnProperty('__url');
    };


    /***
     * Success Upload Image Callback
     * @param asset
     * @param isNew
     */
    let imageSuccessCallback = (asset, isNew = false) => {
        $timeout ( () => {
            let promises = [];
            let __images = (!!$scope.item['images'] && $scope.item['images'].length > 0) ? angular.copy($scope.item['images']) : [];

            $scope.isProgress = false;
            $scope.requestInProgress = false;
            $scope.item['images'] = $scope.images;

            console.warn('asset', asset);
            if (Array.isArray(asset)) {
                if (!isNew) $scope.item['images'] = [];
                _.forEach(asset, (asst) => {
                    $scope.item['images'].push({
                        sys: {
                            "type": "Link",
                            "linkType": "Asset",
                            id: asst.sys.id,
                        }
                    });
                });
                $scope.images = $scope.item['images'];
            } else {
                $scope.item['images'].push({
                    sys: {
                        "type": "Link",
                        "linkType": "Asset",
                        id: asset.sys.id,
                    }
                });
            }

            console.warn($scope.item['images'], asset);
            _.forEach($scope.item['images'], (item) => {
                let endpoint = `${CONFIG.customUploadUrl}contentful/assets?sys.id=${item.sys.id}&sys.type[ne]=${(new Date()).valueOf()}`;
                promises.push($http.get(endpoint));
            });

            $q.all(promises).then((images) => {
                $rootScope.dirtyElems = true;
                let index = 0;
                _.forEach(images, (image) => {
                    let data = image.data.items[0];
                    console.warn('images', data);
                    $scope.item['images'][index] = {
                        __url: data.fields.file.url,
                        __contentType: data.fields.file.contentType,
                        orientation: 'top',
                        description: '',
                        sys: {
                            id: data.sys.id
                        }
                    };

                    let array = __images.filter((image) => { return image.id === data.sys.id });
                    if (array.length > 0) {
                        $scope.item['images'][index].orientation = array[0].orientation;
                        $scope.item['images'][index].description = array[0].description;
                    }
                    index ++;
                });

                if (isNew) {
                    let modalInstance = $uibModal.open({
                        template: appFileView,
                        controller: appFileCtrl,
                        controllerAs: 'vm',
                        resolve: {
                            isMultipleSelection() {
                                return false;
                            },
                            isNoUpload() {
                                return true;
                            },
                            image() {
                                return asset;
                            }
                        }
                    });

                    $rootScope.dirtyElems = true;
                    modalInstance.result.then((addedImage) => {});
                }

            });
        }, 300);
    };


    /***
     * Error Message Callback
     */
    let imageErrorCallback = () => {
        $timeout( () => {
            $scope.isProgress = false;
            ngToast.create({
                className: 'toast-danger',
                content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                timeout: 6000
            });
        });
    };


    /***
     * Uploading image - Creating Asset - Processing Asset - Publishing Asset - Linking Asset to Entry
     * @param imgs
     */
    $scope.uploadImage = (imgs) => {
        /**
         * Upload image
         */
        if (Array.isArray(imgs)) {
            imgs = _.filter(imgs, (img) => { return !img.hasOwnProperty('__url') })
        } else {
            let img = imgs;
            imgs = null;
            img.push(img);
        }

        let promises = [];
        let contentFulPromises = [];
        _.forEach(imgs, (img) => {
            console.log(img);
            promises.push( Upload.upload({
                url: `${CONFIG.customUploadUrl}upload`,
                data: {file: img }
            }));
        });


        $q.all(promises).then((images) => {
            console.log('uploadImage', images);
            let index = 0;
            let count = 0;
            let assets = [];
            _.forEach(images, (data) => {
                /**
                 * Create Asset
                 *
                 */
                let img = imgs[index];

                contentFulPromises.push(ContentFulFactory.createAssetFromFiles());
                ContentFulFactory.createAssetFromFiles()
                    .then((space) => {
                        space.createAsset({
                            fields: {
                                title: {
                                    'en': !!img.$ngfName ? img.$ngfName : !!img.name ? img.name : ''
                                },
                                file: {
                                    'en': {
                                        contentType: !!img.type ? img.type : "image/png",
                                        fileName: !!img.$ngfName ? img.$ngfName : !!img.name ? img.name : '',
                                        upload: data.data.url
                                    }
                                }
                            }
                        })
                            .then((asset) => {
                                console.log('processing...', asset);
                                let p1 = asset.processForLocale('en', { processingCheckRetries: 15 });
                                p1.then((value) => {
                                    console.log(value);
                                }).catch((e) => {
                                    imageErrorCallback(e);
                                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                    $rootScope.raven.captureException(errorMessage);
                                }).then((e) => {
                                    console.log(e);
                                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                    $rootScope.raven.captureException(errorMessage);
                                }, (e) => {
                                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                    $rootScope.raven.captureException(errorMessage);
                                });

                                return p1;
                            })
                            .then((asset) => {
                                console.log('publishing...', asset);
                                let p1 = asset.publish();
                                p1.then((value) => {
                                    console.log(value);
                                }).catch((e) => {
                                    imageErrorCallback(e);
                                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                    $rootScope.raven.captureException(errorMessage);
                                }).then((e) => {
                                    console.log(e);
                                    let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                                    $rootScope.raven.captureException(errorMessage);
                                }, () => {});

                                return p1;
                            })
                            .then((asset) => {
                                count ++;
                                assets.push(asset);
                                if (count === images.length) {
                                    imageSuccessCallback(assets, true);
                                }
                            })
                    })
                    .catch((e) => {
                        let errorMessage = `${e.data.message} - id: ${e.data.details.id}`;
                        $rootScope.raven.captureException(errorMessage);
                        $rootScope.raven.showReportDialog();
                        $scope.isProgress = false;
                        ngToast.create({
                            className: 'toast-warning',
                            content: `${T.HTTP_UPLOAD_ERROR_NOTIFICATION}`,
                            timeout: 2500
                        });
                    })
            })
        });
    };


    $scope.existenceObjectToArray = (obj) => {
        let array = [];

        _.forEach(obj, (value, key) => {
            if (value === true && array.indexOf(key) === -1) {
                array.push(key);
            }
        });

        return array;
    };


    /***
     * Open Modal to linking existing assets to article
     * @param entry
     */
    $scope.linkExistingAssets = (entry) => {
        let endpoint = `assets?mimetype_group=image&sys.type[ne]=${(new Date()).valueOf()}&order=-sys.updatedAt`;
        endpoint += `&skip=0&limit=${CONFIG.paginationResultsPerPageModal}`;

        let images_for_modal = [];

        if ($scope.images.length > 0 && $scope.images[0].hasOwnProperty('__url')) {
            _.forEach($scope.images, (image) => {
                images_for_modal.push({
                    sys: {
                        id: !!image.id ? image.id : image.sys.id,
                        linkType: "Asset",
                        type: "Link"
                    }
                })
            });
        } else {
            images_for_modal = $scope.images;
        }


        console.warn('images_for_modal', images_for_modal);

        let modalInstance = $uibModal.open({
            template: linkAssetsView,
            controller: linkEntriesCtrl,
            controllerAs: 'vm',
            resolve: {
                id() {
                    return $stateParams.id
                },
                items($http) {
                    return $http.get(`${CONFIG.customUploadUrl}contentful/${endpoint}`);
                },
                entry() {
                    return 'images';
                },
                selectedItems() {
                    return images_for_modal;
                },
                formControls() {
                    return formControls;
                },
                type() {
                    return '';
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
            console.log('selectedItem', selectedItem, $scope.images, $scope.item.images);
            imageSuccessCallback(selectedItem.selectedItems, false);
            $document.scrollTop(0, 1000);
        }, () => {
            console.log(`Modal dismissed at: ${new Date()}`);
            $document.scrollTop(0, 1000);
        });
    };

    /***
     * Show File upload
     */
     $scope.showFileUpload = () => {
         $scope.fileUpload = true;
    };


    /***
     * Hide File upload
     */
     $scope.hideFileUpload = () => {
         $scope.fileUpload = false;
    };


    /***
     * Upload Files
     * @param files
     */
    $scope.uploadFiles = (files) => {
        console.log(files);
        $scope.isProgress = true;
        $scope.uploadImage(files);
    };


    /***
     * Tree Options for Images List
     * @type {{dropped: (function(*))}}
     */
    $scope.treeImagesOptions = {
        dropped: (event) => {
            $scope.images = [];
            $scope.images = _.forEach(event.dest.nodesScope.$modelValue, (image) => {return image.hasOwnProperty('___url')});
            console.log('treeImagesOptions', $scope.images, event.dest.nodesScope.$modelValue);
        }
    };


    /***
     * Reset
     */
    $scope.reset = () => {
        $state.reload();
    };


    /***
     * Load Tags
     * @param query
     * @returns {Array.<T>}
     */
    $scope.loadTags = (query) => {
        return $scope.keywords.filter( (keyword) => { return keyword.indexOf(query) > -1 });
    };


    /***
     * Strip format Method
     * @param $html
     */
    $scope.stripFormat = ($html) => {
        /* TODO Create a filter for that like this:
        filter('htmlToPlaintext', () => {
            return (text) => {
        return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
        }
        */
        return text ? String($html).replace(/<[^>]+>/gm, '') : '';
    };


    $scope.setOrientation = (index, orientation) => {
        $scope.orientation = orientation;
        $scope.item.images[index].orientation = orientation;
        console.log('orientantion', orientation, index, $scope.item);
    };


    /*** CROP **/

    $scope.myButtonLabelsObject = {
        rotateLeft: ' (rotate left) ',
        rotateRight: ' (rotate right) ',
        zoomIn: ' (zoomIn) ',
        zoomOut: ' (zoomOut) ',
        fit: ' (fit) ',
        crop: ' [crop] '
    };

    $scope.updateResultImage = (base64) => {
        let array = [];
        base64.name = "img";
        console.log(base64);
        array.push(base64);
        $scope.uploadImage(array);
    };

    $scope.openManageImage = (image) => {
        console.log(image, $scope.images);
        let modalInstance = $uibModal.open({
            template: manageImageView,
            controller: manageImageCtrl,
            resolve: {
                imageUrl() {
                    return image.__url;
                }
            }
        });

        modalInstance.result.then((addedImage) => {
            console.log(image);
            let id_image = image.hasOwnProperty('id') ? image.id : image.sys.id;
            $scope.images = _.filter($scope.images, (img) => { return img.sys.id !== id_image });
            $scope.images.push({
                sys: {
                    type: 'Link',
                    linkType: 'Asset',
                    id: addedImage.asset.sys.id
                }
            });
            console.log(addedImage, $scope.images);

            $http.get(`${CONFIG.customUploadUrl}contentful/assets?sys.id=${ addedImage.asset.sys.id }&sys.type[ne]=${(new Date()).valueOf()}`).then((_data) => {
                let data = _data.data.items[0];
                console.log($scope.item['images']);
                $scope.item['images'] = _.filter($scope.item['images'], (img) => { return (img.hasOwnProperty('id') ? img.id : img.sys.id) !== id_image });
                $scope.item['images'].push({
                    __url: data.fields.file.url,
                    __contentType: data.fields.file.contentType,
                    orientation: 'top',
                    id: data.sys.id
                });
            });
        });
    };

    /*** END CROP **/
    //Bootstrap
    init();
    if ($scope.keywords.length === 0) {
        getAllKeywords();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app.item/appItemsAddEditCtrl.js